import { useAction, useAppSelector } from '@shared/lib/redux'

import { sessionStore } from './session.slice'

export const useSession = () => {
  const sessionState = useAppSelector(sessionStore.selectors.selectSession)
  return {
    ...sessionState
  }
}

export const useCheckAndUpdateSession = () => {
  const state = useAppSelector(sessionStore.selectors.selectStatus)
  const updateSession = useAction(sessionStore.actions.updateSessionStart)
  return {
    updateSession: updateSession,
    ...state
  }
}

export const useCreateSession = () => {
  const state = useAppSelector(sessionStore.selectors.selectStatus)
  const createSession = useAction(sessionStore.actions.createSessionStart)
  return {
    createSession,
    ...state
  }
}

export const useRemoveSession = () => {
  const state = useAppSelector(sessionStore.selectors.selectStatus)
  const removeSession = useAction(sessionStore.actions.removeSessionStart)
  return {
    removeSession,
    ...state
  }
}

export const useSetSession = () => {
  const setSession = useAction(sessionStore.actions.setSession)
  return {
    setSession
  }
}
